import React from 'react'
import '../style/accountPop.scss'
function AccountPop(props) {

  function getAreaName(areaid) {
    var areaname = "";
    if (areaid >= 500) {
      areaname = "苹果" + (areaid - 500) + "区";
    } else if (areaid >= 301 && areaid <= 306) {
      areaname = "腾讯" + (areaid - 300) + "区";
    } else {
      areaname = "安卓" + areaid + "区";
    }
    return areaname;
  }

  return (
    <div className="popup account-pop">
      <div className="content">
        <div className="title"></div>
        <ul className="account-list">
          {props.accountList.map(account => (
            <li key={account.userid}><i></i><span className="area-name">{getAreaName(parseInt(account.areaid))}</span><span className="user-name">{account.name}</span></li>
          ))}
        </ul>
        {props.accountList.length < 5 && <div className="add-account-btn" onClick={props.goBind}></div>}
        <p className="length-tip">*至多绑定5个游戏ID，目前已绑定 <span>{props.accountList.length}/5</span></p>
        <div className="close" onClick={props.toggleAccountPop}></div>
      </div>
    </div>
  )
}

export default AccountPop;
